export namespace NumberHelper {
    export function rank(value: number | string): string {
        return `${value}`.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
    }
}